module.exports = __webpack_public_path__ + "src/assets/img/sd.59d63b74.png";